import React, { useEffect, useContext } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import classes from './MenuPhotoModal.module.scss';
import { GeneralContext } from '../../../context/generalContext';

export default function MenuPhotoModal({ modalPhotoActive, setModalPhotoActive, item, image }) {
  const { activeLanguage } = useContext(GeneralContext);

  // заморозить область за модальным если оно открыто
  useEffect(() => {
    if (modalPhotoActive) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
    } else {
      document.body.style.overflow = 'visible';
      document.body.style.position = '';
    }
  }, [modalPhotoActive]);

  return (
    <div
      className={`${classes.cardModalPhoto} ${modalPhotoActive ? `${classes.cardModalPhotoActive}` : ''}`}
      onClick={() => setModalPhotoActive(false)}
    >
      <div className={classes.cardModalPhotoContent} onClick={e => e.stopPropagation()}>
        <LazyLoadComponent>
          <div className={classes.modalImg} style={{ backgroundImage: `url(${image})` }}>
            <div className={classes.modalName}>
              <p>{activeLanguage === 1 ? item.name : item.name_en || item.name}</p>
              <div className={classes.modalNameLine} />
            </div>
          </div>
        </LazyLoadComponent>
      </div>
    </div>
  );
}
